import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What should I do if my shipment is damaged?',
      answer: 'Contact us immediately within 48 hours of delivery. Take photos of the damaged items and packaging, and keep all materials. Our team will guide you through the claims process and arrange for inspection if needed.',
    },
    {
      question: 'How long does the refund process take?',
      answer: 'Once your return claim is approved, refunds are typically processed within 5-7 business days. The funds will be returned to your original payment method.',
    },
    {
      question: 'Can I return items after 48 hours?',
      answer: 'Our standard policy requires notification within 48 hours of delivery. However, we understand exceptional circumstances may arise. Please contact our support team to discuss your specific situation.',
    },
    {
      question: 'What documentation do I need for a return?',
      answer: 'You will need to provide: delivery receipt, clear photos of the damaged items, photos of the packaging, and a detailed description of the issue. Our team may request additional information during the review process.',
    },
    {
      question: 'Do you offer replacements instead of refunds?',
      answer: 'Yes, we offer both refund and replacement options. If you prefer a replacement, we will expedite the shipping at no additional cost to ensure minimal disruption to your operations.',
    },
    {
      question: 'Who covers the return shipping costs?',
      answer: 'For damaged or incorrect shipments, Next Phase Logistics covers all return shipping costs. We will arrange pickup or provide a prepaid shipping label for your convenience.',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-5xl font-serif font-bold text-gray-900 mb-12 text-center">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-xl overflow-hidden hover:border-[#E67E50] transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-[#F4E8D8]/30 transition-colors"
              >
                <span className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#F5A962] flex items-center justify-center">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-white text-lg`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6 pt-2">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
